import ProductDefaultMediaList from 'components/admin/Products/Segments/ProductDefaultMediaList'
import AttachedMediaList from 'components/shared/MediaBrowser/AttachedMediaList'
import MediaBrowser from 'components/shared/MediaBrowser/MediaBrowser'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  arrayMove,
  arrayPush,
  arrayRemove,
  change,
  formValues,
  registerField,
} from 'redux-form'
import { Grid, Header, Segment } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      registerField,
      arrayPush,
      arrayRemove,
      arrayMove,
      change,
    },
    dispatch
  )
}

class ProductMedia extends React.Component {
  static propTypes = {
    registerField: PropTypes.func.isRequired,
    form: PropTypes.string.isRequired,
  }

  addImage(media) {
    const { arrayPush, form, imageIdList } = this.props
    if (!imageIdList.includes(media)) arrayPush(form, 'imageIdList', media.id)
  }

  deleteImage(index) {
    const { arrayRemove, form } = this.props
    arrayRemove(form, 'imageIdList', index)
  }

  moveImage(oldIndex, newIndex) {
    const { arrayMove, form } = this.props
    arrayMove(form, 'imageIdList', oldIndex, newIndex)
  }

  addDownloadDe(media) {
    const { arrayPush, form, downloadIdsDe } = this.props
    if (!downloadIdsDe.includes(media))
      arrayPush(form, 'downloadIdsDe', media.id)
  }

  addDownloadFr(media) {
    const { arrayPush, form, downloadIdsFr } = this.props
    if (!downloadIdsFr.includes(media))
      arrayPush(form, 'downloadIdsFr', media.id)
  }

  deleteDownloadDe(index) {
    const { arrayRemove, form } = this.props
    arrayRemove(form, 'downloadIdsDe', index)
  }

  deleteDownloadFr(index) {
    const { arrayRemove, form } = this.props
    arrayRemove(form, 'downloadIdsFr', index)
  }

  moveDownloadDe(oldIndex, newIndex) {
    const { arrayMove, form } = this.props
    arrayMove(form, 'downloadIdsDe', oldIndex, newIndex)
  }

  moveDownloadFr(oldIndex, newIndex) {
    const { arrayMove, form } = this.props
    arrayMove(form, 'downloadIdsFr', oldIndex, newIndex)
  }

  deleteManualDe() {
    const { change, form } = this.props
    change(form, 'manualMediumIdDe', null)
  }

  deleteDatasheetDe() {
    const { change, form } = this.props
    change(form, 'datasheetMediumIdDe', null)
  }

  deleteExplodedDe() {
    const { change, form } = this.props
    change(form, 'explodedMediumIdDe', null)
  }

  deleteManualFr() {
    const { change, form } = this.props
    change(form, 'manualMediumIdFr', null)
  }

  deleteDatasheetFr() {
    const { change, form } = this.props
    change(form, 'datasheetMediumIdFr', null)
  }

  deleteExplodedFr() {
    const { change, form } = this.props
    change(form, 'explodedMediumIdFr', null)
  }

  customActions(medium) {
    const { change, form } = this.props
    return [
      {
        icon: 'image',
        disabled: medium.content_type === 'application/pdf',
        text: I18n.t('admin.mediaBrowser.as_image'),
        color: config.semantic_ui.primary_color,
        onClick: (event) => {
          event.preventDefault()
          this.addImage(medium)
        },
      },
      {
        icon: 'download',
        disabled: medium.content_type !== 'application/pdf',
        text: I18n.t('admin.mediaBrowser.as_download_de'),
        color: config.semantic_ui.primary_color,
        onClick: (event) => {
          event.preventDefault()
          this.addDownloadDe(medium)
        },
      },
      {
        icon: 'download',
        disabled: medium.content_type !== 'application/pdf',
        text: I18n.t('admin.mediaBrowser.as_download_fr'),
        color: config.semantic_ui.primary_color,
        onClick: (event) => {
          event.preventDefault()
          this.addDownloadFr(medium)
        },
      },
      {
        icon: 'book',
        disabled: medium.content_type !== 'application/pdf',
        text: I18n.t('admin.mediaBrowser.user_manual_de'),
        onClick: (event) => {
          event.preventDefault()
          change(form, 'manualMediumIdDe', medium.id)
        },
      },
      {
        icon: 'table',
        disabled: medium.content_type !== 'application/pdf',
        text: I18n.t('admin.mediaBrowser.datasheet_de'),
        onClick: (event) => {
          event.preventDefault()
          change(form, 'datasheetMediumIdDe', medium.id)
        },
      },
      {
        icon: 'map outline',
        disabled: medium.content_type !== 'application/pdf',
        text: I18n.t('admin.mediaBrowser.exploded_diagram_de'),
        onClick: (event) => {
          event.preventDefault()
          change(form, 'explodedMediumIdDe', medium.id)
        },
      },
      {
        icon: 'book',
        disabled: medium.content_type !== 'application/pdf',
        text: I18n.t('admin.mediaBrowser.user_manual_fr'),
        onClick: (event) => {
          event.preventDefault()
          change(form, 'manualMediumIdFr', medium.id)
        },
      },
      {
        icon: 'table',
        disabled: medium.content_type !== 'application/pdf',
        text: I18n.t('admin.mediaBrowser.datasheet_fr'),
        onClick: (event) => {
          event.preventDefault()
          change(form, 'datasheetMediumIdFr', medium.id)
        },
      },
      {
        icon: 'map outline',
        disabled: medium.content_type !== 'application/pdf',
        text: I18n.t('admin.mediaBrowser.exploded_diagram_fr'),
        onClick: (event) => {
          event.preventDefault()
          change(form, 'explodedMediumIdFr', medium.id)
        },
      },
    ]
  }

  render() {
    const dark = config.theme.dark
    // props
    const {
      manualMediumIdDe,
      datasheetMediumIdDe,
      explodedMediumIdDe,
      manualMediumIdFr,
      datasheetMediumIdFr,
      explodedMediumIdFr,
    } = this.props

    const imageIdList = this.props.imageIdList || []
    const downloadIdsDe = this.props.downloadIdsDe || []
    const downloadIdsFr = this.props.downloadIdsFr || []

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column tablet={12} computer={8} largeScreen={8} widescreen={8}>
            <MediaBrowser
              addMedium={(mediumId) => this.addImage(mediumId)}
              customActions={(medium) => this.customActions(medium)}
            />
          </Grid.Column>
          <Grid.Column tablet={12} computer={4} largeScreen={4} widescreen={4}>
            <Grid stackable>
              <Grid.Row>
                <Grid.Column
                  tablet={6}
                  computer={12}
                  largeScreen={12}
                  widescreen={12}>
                  <Segment
                    attached
                    className={classNames([dark && 'inverted'])}>
                    <Header
                      as="h4"
                      content={I18n.t('admin.mediaBrowser.standard_downloads')}
                    />
                  </Segment>
                  <ProductDefaultMediaList
                    manualMediumIdDe={manualMediumIdDe}
                    datasheetMediumIdDe={datasheetMediumIdDe}
                    explodedMediumIdDe={explodedMediumIdDe}
                    manualMediumIdFr={manualMediumIdFr}
                    datasheetMediumIdFr={datasheetMediumIdFr}
                    explodedMediumIdFr={explodedMediumIdFr}
                    deleteManualDe={() => this.deleteManualDe()}
                    deleteDatasheetDe={() => this.deleteDatasheetDe()}
                    deleteExplodedDe={() => this.deleteExplodedDe()}
                    deleteManualFr={() => this.deleteManualFr()}
                    deleteDatasheetFr={() => this.deleteDatasheetFr()}
                    deleteExplodedFr={() => this.deleteExplodedFr()}
                  />
                </Grid.Column>

                <Grid.Column
                  tablet={6}
                  computer={12}
                  largeScreen={12}
                  widescreen={12}>
                  <Segment
                    attached
                    className={classNames([dark && 'inverted'])}>
                    <Header
                      as="h4"
                      content={I18n.t('admin.mediaBrowser.product_images')}
                    />
                  </Segment>
                  <AttachedMediaList
                    mediaIdList={imageIdList}
                    moveMedium={(oldIndex, newIndex) =>
                      this.moveImage(oldIndex, newIndex)
                    }
                    deleteMedium={(index) => this.deleteImage(index)}
                  />
                  <Segment
                    attached
                    className={classNames([dark && 'inverted'])}>
                    <Header
                      as="h4"
                      content={I18n.t('admin.mediaBrowser.downloads_de')}
                    />
                  </Segment>
                  <AttachedMediaList
                    mediaIdList={downloadIdsDe}
                    moveMedium={(oldIndex, newIndex) =>
                      this.moveDownloadDe(oldIndex, newIndex)
                    }
                    deleteMedium={(index) => this.deleteDownloadDe(index)}
                  />
                  <Segment
                    attached
                    className={classNames([dark && 'inverted'])}>
                    <Header
                      as="h4"
                      content={I18n.t('admin.mediaBrowser.downloads_fr')}
                    />
                  </Segment>
                  <AttachedMediaList
                    mediaIdList={downloadIdsFr}
                    moveMedium={(oldIndex, newIndex) =>
                      this.moveDownloadFr(oldIndex, newIndex)
                    }
                    deleteMedium={(index) => this.deleteDownloadFr(index)}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

ProductMedia = connect(mapStateToProps, mapDispatchToProps)(ProductMedia)
ProductMedia = formValues(
  'imageIdList',
  'downloadIdsDe',
  'downloadIdsFr',
  'manualMediumIdDe',
  'datasheetMediumIdDe',
  'explodedMediumIdDe',
  'manualMediumIdFr',
  'datasheetMediumIdFr',
  'explodedMediumIdFr'
)(ProductMedia)
export default ProductMedia



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductMedia.jsx